import { apiClient } from '@/shared/lib/apiClient';
import type {
  AdminSubscriptionsMonitorListResponse,
  ListAdminSubscriptionsMonitorQuery,
} from '../types/adminSubscription';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function listAdminSubscriptionsMonitor(
  query?: ListAdminSubscriptionsMonitorQuery,
): Promise<AdminSubscriptionsMonitorListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.status) params['status'] = query.status;
  if (query?.product_id) params['product_id'] = query.product_id;
  if (query?.product_slug) params['product_slug'] = query.product_slug;
  if (query?.plan_id) params['plan_id'] = query.plan_id;
  if (query?.tenant_id) params['tenant_id'] = query.tenant_id;
  if (query?.entitlement_status) params['entitlement_status'] = query.entitlement_status;
  if (query?.search) params['search'] = query.search;
  if (query?.expiring_soon_days !== undefined) {
    params['expiring_soon_days'] = String(query.expiring_soon_days);
  }
  if (query?.payment_issue !== undefined) {
    params['payment_issue'] = query.payment_issue ? 'true' : 'false';
  }
  if (query?.from) params['from'] = query.from;
  if (query?.to) params['to'] = query.to;

  const res = await apiClient.get<ApiResponse<AdminSubscriptionsMonitorListResponse>>(
    '/api/v1/admin/subscriptions',
    { params },
  );
  return res.data;
}
